"use client";

import * as SeparatorPrimitive from "@radix-ui/react-separator";
import * as React from "react";

import { css, cva } from "@/../styled-system/css";

const separator = cva({
  base: {
    flexShrink: 0,
    bg: "zinc.200",
  },
  variants: {
    orientation: {
      horizontal: {
        h: "1px",
        w: "100%",
      },
      vertical: {
        h: "100%",
        minH: "full",
        w: "1px",
      },
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
});

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> & {
    css?: object;
  }
>(
  (
    {
      css: cssProp = {},
      orientation = "horizontal",
      decorative = true,
      ...props
    },
    ref,
  ) => {
    const className = css(separator.raw({ orientation: orientation }), cssProp);
    return (
      <SeparatorPrimitive.Root
        ref={ref}
        decorative={decorative}
        orientation={orientation}
        className={className}
        {...props}
      />
    );
  },
);

Separator.displayName = SeparatorPrimitive.Root.displayName;
export { Separator };
